import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import apps, { CONTACT_EMAIL } from "../data/apps";
import PlayBadge from "../components/PlayBadge";
import NotFoundPage from "./NotFoundPage";

export default function AppPage() {
  const { slug } = useParams();
  const app = apps.find((a) => a.slug === slug);

  useEffect(() => {
    if (app) document.title = `${app.name} | Northwind`;
    return () => {
      document.title = "Northwind | Android apps";
    };
  }, [app]);

  if (!app) return <NotFoundPage />;

  return (
    <div className="container section">
      <Link to="/" className="back-link">
        ← All apps
      </Link>
      <div className="app-hero">
        <img src={app.icon} alt={`${app.name} icon`} width={112} height={112} />
        <div>
          <h1>{app.name}</h1>
          <p className="lead">{app.tagline}</p>
          <PlayBadge url={app.playStoreUrl} />
        </div>
      </div>

      {app.screenshots.length > 0 && (
        <div className="shots" aria-label={`${app.name} screenshots`}>
          {app.screenshots.map((src, i) => (
            <img
              key={src}
              src={src}
              alt={`${app.name} screenshot ${i + 1}`}
              loading="lazy"
            />
          ))}
        </div>
      )}

      <h2>About</h2>
      {app.description.map((p) => (
        <p key={p}>{p}</p>
      ))}

      <h2>Features</h2>
      <ul className="feature-list">
        {app.features.map((f) => (
          <li key={f}>{f}</li>
        ))}
      </ul>

      <h2>Support</h2>
      <p>
        Need help with {app.name}? Email{" "}
        <a href={`mailto:${CONTACT_EMAIL}?subject=${app.name} support`}>
          {CONTACT_EMAIL}
        </a>
        . Read our <Link to="/privacy">privacy policy</Link>.
      </p>
    </div>
  );
}
